export const getPageLang = () => document.documentElement.lang